import { dispatch } from "@rematch/core";
import { push } from "react-router-redux";
import {
  invitesService,
  unGaurdedInvitesService,
  userWorkspaceManagerService,
  searchInviteUsersService,
  mailsenderService,
  unGaurdedCheckUserService,
  checkUserService,
  registerUserService,
  registerAccountUserService,
} from "../../services/feathers.service";
import { toastr } from "react-redux-toastr";
import uniqid from "uniqid";

const initialState = {
  invitationError: null,
  invitationData: null,
  inviteObj: {},
  showUserResourcePane: null,
  captchaResponse: null,
  state: 0,
  unitRoleToAdd: "Member",
  showInviteResourcePane: null,
  inviteUserList: [],
  userRole: "",
  searchInviteeQuery: {
    firstName: "",
    lastName: "",
    email: "",
    role: "",
    organizationId: "",
    referenceId: "",
  },
  searchUserArr: [],
  searchInviteUserArr: [],
  addedAccountUser: null,
  invites: [],
};

export default {
  state: initialState,
  reducers: {
    setError(state, payload) {
      return {
        ...state,
        invitationError: payload,
      };
    },
    setInvitationData(state, payload) {
      return {
        ...state,
        invitationData: payload,
      };
    },
    setCaptchaResponse(state, payload) {
      return {
        ...state,
        captchaResponse: payload,
      };
    },
    setState(state, payload) {
      return {
        ...state,
        state: payload,
      };
    },
    storeUser(state, payload) {
      return {
        ...state,
        inviteObj: payload,
      };
    },
    showResourcePane(state, payload) {
      return {
        ...state,
        showUserResourcePane: payload,
      };
    },
    clear() {
      return initialState;
    },
    setInviteResource(state, payload) {
      return {
        ...state,
        showInviteResourcePane: payload,
      };
    },
    storeInviteData(state, payload) {
      return {
        ...state,
        inviteUserList: payload,
      };
    },
    storeRole(state, payload) {
      return {
        ...state,
        userRole: payload,
      };
    },
    setSearchUser(state, payload) {
      return {
        ...state,
        searchUserArr: payload,
      };
    },
    setSearchInviteUser(state, payload) {
      return {
        ...state,
        searchInviteUserArr: payload,
      };
    },
    setAddedAccountUser(state, payload) {
      return {
        ...state,
        addedAccountUser: payload,
      };
    },
    setInviteList(state, payload) {
      return {
        ...state,
        invites: payload,
      };
    },
  },
  effects: {
    async getInvitesAsync(payload) {
      try {
        let invitations = await invitesService.find({
          query: {
            organizationId: payload.organizationId,
            referenceId: payload.referenceId,
            isAccepted: false,
            isDeclined: false,
            isDeleted: false,
            //"isIndirect": false,
            $limit: payload.query.$limit,
            $skip: payload.query.$skip,
            $sort: payload.query.$sort,
            $or: payload.query.$or,
          },
        });
        dispatch.invite.setInviteList(invitations);
      } catch (err) {
        dispatch.invite.setError(err);
      }
    },
    async declineInviteAsync(payload) {
      try {
        dispatch.invite.setError(null);
        payload.isDeclined = true;
        payload.isActive = false;
        await invitesService.patch(payload._id, payload);
        // const invitationData = await unGaurdedInvitesService.patch(
        //   payload._id,
        //   {
        //     payload: payload,
        //   }
        // );
        // dispatch.invite.setInvitationData(invitationData);
        dispatch.invite.setState(2);
      } catch (err) {
        dispatch.invite.setError(err);
      }
    },
    async approveInviteAsync(payload) {
      try {
        dispatch.invite.setError(null);
        const users = await unGaurdedCheckUserService.get(payload.email);
        if (users.userFound) {
          payload.accountUserId = users.userFound._id;
          payload.inviteFlag = true;
          payload.userFoundFlag = true;
          await unGaurdedInvitesService.patch(payload._id, {
            payload: payload,
          });
          return dispatch(push("/login"));
        } else {
          const userObject = payload;
          //userObject.profilePic = "http://res.cloudinary.com/aspenify/image/upload/v1535094547/uhmidgexdzniimugr7h0.jpg"
          userObject.timeZone =
            Intl.DateTimeFormat().resolvedOptions().timeZone;
          userObject.uniqueId = uniqid.time();
          userObject.String = "AcceptAllInvitation";
          let accountUser = await registerAccountUserService.create(userObject);

          dispatch.registerAccount.endRegistration(accountUser);
          dispatch.registerAccount.setError("Success");
          dispatch.invite.setState(1);
        }
      } catch (err) {
        dispatch.registerAccount.setError(err.message);
        dispatch.invite.setError(err);
      }
    },
    async registerUserAsync(payload, rootState) {
      //payload.profilePic = "http://res.cloudinary.com/aspenify/image/upload/v1535094547/uhmidgexdzniimugr7h0.jpg"
      const user = payload;
      try {
        dispatch.invite.setError(null);
        const orgMapping = {
          name: user.organizationName,
          id: user.organization,
          role: user.role,
        };
        user.organizations = [];
        user.isVerified = true;
        user.organizations.push(orgMapping);
        user.captchaResponse = rootState.invite.captchaResponse;
        user.Str = "AcceptAllInvitation";
        await registerUserService.create(user);
      } catch (err) {
        dispatch.register.setError(err);
        throw err;
      }
    },

    async getInviteDetailsAsync(payload) {
      try {
        dispatch.invite.clear();
        const invitationData = await unGaurdedInvitesService.get(payload);
        dispatch.invite.setInvitationData(invitationData);
      } catch (err) {
        if (err.code === 400 || err.code === 404 || err.code === 500) {
          return dispatch(push(`/invite/404`));
        }
        dispatch.invite.setError(err);
      }
    },
    async sendInviteAsync(payload) {
      const invitee = payload;
      invitee.email = invitee.email.toLowerCase();
      try {
        if (invitee.organization === invitee.referenceId) {
          const invitationedRecord = await invitesService.find({
            query: {
              email: invitee.email,
              referenceId: invitee.referenceId,
              organization: invitee.organization,
              isAccepted: false,
              isDeclined: false,
            },
          });
          if (
            invitationedRecord.data.length &&
            invitationedRecord.data[0].isIndirect
          ) {
            let orgInvite = invitationedRecord.data[0];
            orgInvite.isIndirect = false;
            orgInvite.role = invitee.role;
            orgInvite.firstName = invitee.firstName;
            orgInvite.lastName = invitee.lastName;
            await invitesService.patch(
              invitationedRecord.data[0]._id,
              orgInvite
            );
            toastr.success("Message", "User invited successfully");
          } else if (
            invitationedRecord.data.length &&
            !invitationedRecord.data[0].isIndirect
          ) {
            toastr.error("Message", "User with same email id already invited");
          } else {
            const users = await checkUserService.get(invitee.email);
            let temp;
            if (users.userFound) {
              temp = users.userFound.organizations.filter((Org) => {
                return Org.id === invitee.organization;
              });
            }
            if (users.userFound && temp.length) {
              toastr.error("Message", "User with same email id already exists");
            } else {
              await invitesService.create(invitee);
              toastr.success("Message", "User invited successfully");
            }
          }
        } // end of if
        else {
          await invitesService.create(invitee);
          toastr.success("Message", "User invited successfully");
        }
        dispatch.invite.clearInviteSearchFilter();
      } catch (err) {
        dispatch.invite.setError(err);
        if (
          err.response &&
          err.response.statusCode &&
          (err.response.statusCode === 409 || err.response.statusCode === 500)
        ) {
          toastr.error("Message", "User with same email id already exists");
        }
        throw err;
      }
    },

    async createInvitationAsync(payload) {
      payload.email = payload.email.toLowerCase();
      try {
        await invitesService.create(payload);
        if (payload.organizationId === payload.referenceId) {
          await dispatch.organizationUnit.getOrgByIdAsync(
            payload.organizationId
          );
        } else {
          await dispatch.organizationUnit.getSubOrgByIdAsync(
            payload.referenceId
          );
        }
        toastr.success("Message", "User invited successfully");
      } catch (err) {
        throw err;
      }
    },
    async inviteNewUser (payload,state) {
      try {
        payload.organizationId = state.app.selectedOrganisation.id.toString(); 
        payload.teamName = state.organizationUnit.createdTeam.name;
        payload.referenceId = state.organizationUnit.createdTeam._id.toString();
        payload.from = state.app.user._id;
        await invitesService.create(payload);
        toastr.success("Message", `${payload.firstName} invited successfully`);
      } catch (err) {
        throw err;
      }
    },
    async sendInviteByAccountAsync(payload) {
      payload.email = payload.email.toLowerCase();
      try {
        // check user existing in the sysytem
        const users = await checkUserService.get(payload.email);
        let temp = [];
        if (users.userFound) {
          temp = users.userFound.accounts.filter((account) => {
            return account.id === payload.accountId;
          });
        }
        if (users.userFound && temp.length > 0) {
          users.userFound.role = temp[0].role;
          dispatch.invite.addedAccountUserData(users.userFound);
        } else {
          await invitesService.create(payload);
          await dispatch.account.getInviteByAccountIdAsync(payload.accountId);
          await dispatch.invite.addedAccountUserData(null);
          toastr.success("Message", "User invited successfully");
          if (payload.role === "platformAdmin") {
            return dispatch(push(`/app/platform/users/1`));
          } else {
            return dispatch(push(`/app/${payload.accountId}/users/2`));
          }
        }
      } catch (err) {
        throw err;
      }
    },
    addedAccountUserData(payload) {
      dispatch.invite.setAddedAccountUser(payload);
    },
    clearInviteError(payload) {
      dispatch.invite.setError(payload);
    },

    async deleteInvitaionAsync(payload) {
      try {
        await invitesService.remove(payload._id);
        toastr.success("Message", "Invitation deleted successfully");
      } catch (err) {
        dispatch.invite.setError(err);

        toastr.error("Message", "Failed to delete invitation");
        throw err;
      }
    },

    async resendInvitation(payload) {
      let emailObject = payload;
      emailObject.toEmail = emailObject.toEmail.toLowerCase();
      emailObject.invite.isActive = true;
      emailObject.invite.isDeclined = false;
      try {
        await mailsenderService.create(emailObject);
        await invitesService.patch(payload.invite._id, emailObject);
        toastr.success("Message", "Invitation sent successfully");
      } catch (err) {
        dispatch.invite.setError(err);
        toastr.error("Message", "Failed to resend invite");
      }
    },
    async addUserInSubUnitAsync(payload) {
      try {
        await userWorkspaceManagerService.create(payload);
        await dispatch.organizationTab.getUsersTreeAsync({
          id: payload.teamId,
          accountId: payload.accountId,
        });
        if (payload.organizationId === payload.teamId) {
          await dispatch.organizationUnit.getOrgByIdAsync(payload.teamId);
        } else {
          await dispatch.organizationUnit.getSubOrgByIdAsync(payload.teamId);
        }

        if (payload.stringType === "TeamMapping") {
          dispatch.initiatives.getSuborgDetailsById(payload.teamId);
        } else if (payload.stringType === "SubOrgUserAddModal") {
          dispatch.organizationTab.getSelectedSubOrgUsersAsync(payload.teamId);
        }
        toastr.success("Message", "User added successfully");
      } catch (err) {
        dispatch.invite.setError(err);
        toastr.error("Message", "Failed to add user");
      }
    },

    async getSearchedInviteUsers(payload) {
      if (payload.value) {
        try {
          let searchedUsersData = await searchInviteUsersService.find({
            query: payload,
          });
          await dispatch.invite.setSearchUser(searchedUsersData.userResult);
          await dispatch.invite.setSearchInviteUser(
            searchedUsersData.inviteResult
          );
        } catch (err) {
          dispatch.invite.setError(err);
        }
      }
    },
    updateState(user) {
      dispatch.invite.storeUser(user);
    },
    userResourcePane(flag) {
      dispatch.invite.showResourcePane(flag);
    },
    clearInviteSearchFilter() {
      dispatch.invite.setSearchUser([]);
      dispatch.invite.setSearchInviteUser([]);
    },
    setInviteResourcePane(payload) {
      dispatch.invite.setInviteResource(payload);
    },
    updateStateForResource(payload) {
      dispatch.invite.storeInviteData(payload);
    },
    storeUserRole(payload) {
      dispatch.invite.storeRole(payload);
    },
    async searchInvitees(payload) {
      try {
        let searchQuery = {};

        if (payload.firstName) {
          payload.firstName = payload.firstName.replace(".", "\\.");
          searchQuery.firstName = { $regex: payload.firstName, $options: "i" };
        }
        if (payload.lastName) {
          payload.lastName = payload.lastName.replace(".", "\\.");
          searchQuery.lastName = { $regex: payload.lastName, $options: "i" };
        }
        if (payload.email) {
          payload.email = payload.email.replace(".", "\\.");
          searchQuery.email = { $regex: payload.email, $options: "i" };
        }
        searchQuery.organizationId = payload.organizationId;
        searchQuery.referenceId = payload.referenceId;

        if (payload.role) {
          searchQuery.role = payload.role;
        }
        searchQuery.isAccepted = false;
        searchQuery.isDeclined = false;
        searchQuery.isDeleted = false;
        let users = await invitesService.find({
          query: searchQuery,
        });
        dispatch.invite.setInviteList(users);
      } catch (err) {}
    },

    updateInviteList(payload, state) {
      let indexOfInvite;
      if (state.invite.invites && state.invite.invites.data) {
        for (let [index, invite] of state.invite.invites.data.entries()) {
          if (invite._id.toString() === payload._id.toString()) {
            indexOfInvite = index;
            state.invite.invites.data.splice(indexOfInvite, 1);
            state.invite.invites.total -= 1;
            dispatch.invite.setInviteList(
              Object.assign({}, state.invite.invites)
            );
            dispatch.organizationUnit.showResourecePane(null);
            break;
          }
        }
      }

      let indexOfDeclineInvitePlaybook;
      if (
        state.lifeCycle.playbookInvitaions &&
        state.lifeCycle.playbookInvitaions.length
      ) {
        for (let [
          index,
          invite,
        ] of state.lifeCycle.playbookInvitaions.entries()) {
          if (invite._id.toString() === payload._id.toString()) {
            indexOfDeclineInvitePlaybook = index;
            state.lifeCycle.playbookInvitaions.splice(
              indexOfDeclineInvitePlaybook,
              1
            );
            dispatch.lifeCycle.setInvitaionInsidePlaybook(
              Object.assign({}, state.lifeCycle.playbookInvitaions)
            );
            break;
          }
        }
      }
    },
  },
};
